import { Component, OnInit } from '@angular/core'
import { Observable } from 'rxjs'
import { CountableSummary } from 'src/app/models/period-aggregate-amounts.model'
import { AppState } from 'src/app/reducers'
import { Store } from '@ngrx/store'
import {
  getSpecialUmhpPageviews,
  getLoading,
} from 'src/app/selectors/period-aggregate-amounts.selector'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import { Artist } from 'src/app/models/artist.model'
import {
  getDataCollectBySpecialUmhpPageviews,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-special-umhp-pageview',
    templateUrl: './aggregated-amounts-special-umhp-pageview.component.html',
    styleUrls: ['./aggregated-amounts-special-umhp-pageview.component.scss'],
    standalone: false
})
export class AggregatedAmountsSpecialUmhpPageviewComponent implements OnInit {
  specialUmhpPageView$: Observable<CountableSummary>
  loading$: Observable<boolean>
  selectedArtist$: Observable<Artist>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.specialUmhpPageView$ = this.store.select(getSpecialUmhpPageviews)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectBySpecialUmhpPageviews)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
